export default function SocialChromeOutline() {
  return (
    <div
      className="ion-icon-social-chrome-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g id="Icon">
	<g>
		<path d="M256,32C132.8,32,32,132.8,32,256s100.8,224,224,224s224-100.8,224-224S379.2,32,256,32z M256,76.799
			c66.084,0,124.315,35.843,154.558,89.602H256c-43.685,0-79.517,31.358-87.358,71.684l-53.758-92.969
			C147.358,103.685,198.884,76.799,256,76.799z M323.2,256c0,36.957-30.243,67.2-67.2,67.2s-67.2-30.243-67.2-67.2
			s30.243-67.2,67.2-67.2S323.2,219.043,323.2,256z M76.799,256c0-32.484,8.958-62.716,24.644-89.6L178.715,300.8l0,0
			c15.685,26.885,43.685,44.8,77.285,44.8c10.085,0,20.157-2.241,29.116-5.6l-53.758,92.958C144,421.758,76.799,346.715,76.799,256z
			 M256,435.201L333.285,300.8l0,0c7.831-13.442,12.314-28,12.314-44.8c0-26.885-12.314-50.399-31.358-67.2h107.517
			c8.957,21.284,13.443,43.685,13.443,67.2C435.201,354.557,354.557,435.201,256,435.201z"/>
	</g>
</g>
</svg>
`,
      }}
    />
  )
}
